module.exports = __webpack_public_path__ + "img/tractorUnitFrontRightOutline.eae519cd.svg";